/*
    !x && x !== '0' => this is a logical expression that evaluates to true if x is a falsy value (like null, undefined, false, 0, NaN, or an empty string), but not the string '0'.
    ? '' : x => this is a ternary conditional expression that returns an empty string '' if the logical expression is true, otherwise it returns the value of x.

    Here are some examples of how this function behaves with different input values:

    safeVal(null) returns '' (empty string)
    safeVal(undefined) returns '' (empty string)
    safeVal(false) returns '' (empty string)
    safeVal(0) returns '' (empty string)
    safeVal(NaN) returns '' (empty string)
    safeVal('') returns '' (empty string)
    safeVal('0') returns '' (empty string)
    safeVal(42) returns 42
    safeVal('Hello') returns 'Hello'
 */

export const safeVal = x => !x && x !== 0 && x !== '0' ? '' : x